<template>
  <div>

    <div class="row">
      <div
        class="col-xs-12 col-sm-6 col-md-4 col-lg-3 column"
        v-for="listing in listings"
        :key="randomString(listing)"
        style="cursor:pointer;"
        @click="showInfo(listing)"
      >
        <div class="pane"
          :style="listingStyle(listing)">
          <div v-if="listing.photo">
            <a :href="`https://${listing.website}`" target="_blank">
              <img
                v-if="listing.photo"
                :src="`https://api.everythingcheeranddance.com/public/photo?key=${listing.photo}`"
                width="200px"
                height="200px"
                style="
                  border-radius: 20px;
                  object-fit: cover;
                  margin-top: 10px;
                  margin-bottom: 10px;
                "
              />
            </a>
          </div>
          <h4 :class="{
            'small':listing.priceName == 'Small',
            'medium':listing.priceName == 'Medium',
            'large':listing.priceName == 'Large',
            'pane':true
            }"
            :style="listingStyle(listing)"
            >{{ listing.city }}, {{ listing.state }}</h4>
          <p v-for="field in computedFields(listing)" :key="field.id">
            <small :style="listingStyle(listing)"><strong>{{ field.name }}</strong></small
            ><br />
            <a
            :href="'mailto:' + utils.findFieldValue(listing,field.name)"
            v-if="field.type == 'Email'"
            >{{utils.findFieldValue(listing,field.name)}}</a>
            <a
            target="_blank"
            :href="utils.findFieldValue(listing,field.name)"
            v-else-if="field.type == 'Website'"
            >{{utils.findFieldValue(listing,field.name)}}</a>
            <a v-else>{{utils.findFieldValue(listing,field.name)}}</a>
          </p>
          <span v-if="listing.favorite">
            <button
              @click="unfavorite(listing)"
              class="btn btn-warning btn-orange white"
            >
              <img src="/static/heart.png" width="25px" height="25px" />
              {{listing.favoriteCount}}
            </button>
          </span>
          <span v-else>
            <button
              @click="favorite(listing)"
              class="btn btn-warning btn-orange white"
            >
              <img src="/static/heart-outline.png" width="25px" height="25px" />
              {{listing.favoriteCount}}
            </button>
          </span>
        </div>
      </div>
    </div>
    <listing-modal :listing="selectedListing" @dismissModal="dismissModal"/>
  </div>
</template>

<script>
import Utils from "@/Utils/Utils";
import ListingModal from "./ListingModal.vue";
export default {
  name: "FeedCards",
  components: {
    ListingModal
  },
  data() {
    return {
      utils: Utils,
      selectedListing: null,
    };
  },
  props: {
    listings: {
      default: [],
    },
    fields: {
      default: [],
    },
    showSearch: {
      default: false,
    }
  },
  computed: {
    tableFields() {
      let fields = this.fields.filter((it) => {
        return it.showInTable == 1;
      });
      if (!fields) {
        return [];
      }

      return fields;
    },
    searchableFields() {
      return this.fields.filter((it) => {
        return it.searchable == 1;
      });
    },
  },
  methods: {
    listingStyle(listing){
      if(listing.priceName == 'Large') {
        return {
          background:listing.backgroundColor || '#f2f2f2',
          color:listing.textColor || '#000000'
        }
      }

      return {}
    },
    computedFields(listing) {
      console.log("Load computed");
      if (listing.showInfo) {
        console.log("show more info");
        return this.fields;
      }

      return this.tableFields;
    },
    hideModal() {
      console.log("hide");
      this.modalListing = null;
    },
    findShowInTableFromField(listing, fieldName) {
      var value = "";
      listing.fields.forEach((field) => {
        if (field.name == fieldName) {
          value = field.showInTableOnSmall;
        }
      });
      return value == 1 ? true : false;
    },
    getImgUrl(pic) {
      return require("@/assets/" + pic);
    },
    favorite(listing) {
      this.$emit("favorite", listing);
    },
    unfavorite(listing) {
      this.$emit("unfavorite", listing);
    },
    showInfo(listing) {
      this.selectedListing = listing
      // this.$emit("showInfo", listing);

      const options = {listing:listing,name:'ListingModal',};
      const style = { width: "85%", height: "auto", scrollable:true };
      const events = {
        opened: () => console.log("Opened"),
        closed: () => console.log("Closed")
      };

      this.$modal.show(ListingModal, options, style, events);

    },
    toggleShowSearch() {
      console.log("show search");
      this.$emit("showSearch");
    },
    randomString(listing) {
      return this.utils.randomString(20);
    },
    dismissModal() {
      console.log("dismiss")
      this.selectedListing = null
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 768px) {
  .hidden-sm {
    display: none;
  }
}

.white {
  color: white;
}

.search {
  background: #f2f2f2;
  border-radius: 10px;
  margin: 0px;
  padding: 20px;
  margin-bottom: 20px;
}

.small {
  font-size: 90%;
}

.medium {
  font-size: 130%;
}

.large {
  font-size: 170%;
}

.pane {
  width: 100%;
  min-height: 100px;
  background: #f2f2f2;
  border-radius: 10px;
  margin-top: 20px;
  padding: 10px;
}

.row {
  margin-top: 20px;
}

.btn-blue {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/FeedCards.vue